import Vue from 'vue'
import VueRouter from 'vue-router'
import module from "./module";
import Home from '../views/home/Index'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '首页',
    component: Home
  },
  ...module
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
